<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template #headerTitle>
            <h5 class="card-title text-primary">
              <strong>YEARLY PLAN</strong>
            </h5>
          </template>
          <template #body>
            <div class="relative w-100">
              <CustomNav
                :items="tabs"
                @item-click="(value) => (activeTab = value)"/>
              <template v-if="activeTab === 'fleet_availability_target'">
                <AvailabilityTarget/>
              </template>
              <template v-else>
                <MaintenanceDocking/>
              </template>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import FormTargetFleetAvailability from './FormTargetFleetAvailability.vue'
import CustomNav from '@/src/components/global/CustomNav.vue';
import AvailabilityTarget from './Tabs/PlanByFleetCategory.vue';
import MaintenanceDocking from './Tabs/PlanByFleet.vue';

export default {
  name: 'ListTargetFleetAvailabilityYear',
  data() {
    return {
      activeTab: 'fleet_availability_target',
      tabs :[
        {
          label:'Plan By Fleet Category',
          value:'fleet_availability_target',
        },
        {
          label:'Plan By Fleet',
          value:'maintenance_and_docking_plan',
        },
      ]
    }
  },
  components: {
    FormTargetFleetAvailability,
    CustomNav,
    AvailabilityTarget,
    MaintenanceDocking
  },
  methods: {},
}
</script>
<style scoped>
.overflow-auto {
  overflow: auto !important;
}
.relative {
  position: relative;
}
.col-month {
  min-width: 160px;
}
.sticky {
  position: sticky !important;
}
.col-1 {
  left: 0px !important;
  z-index: 20;
  min-width: 40px;
}
.col-2 {
  left: 40px !important;
  z-index: 20;
  min-width: 200px;
  max-width: 200px;
}
.col-3 {
  left: 240px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
.col-4 {
  left: 340px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
.col-5 {
  left: 440px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
</style>
